import { FunctionComponent } from 'react';
import { DialogModal } from '../../../app-kit/components/DialogModal/DialogModal';
import { StreetPageVGDisclaimerModalContentWithData } from './StreetPageVGDisclaimerModalContent/StreetPageVGDisclaimerModalContentWithData';

interface VGDisclaimerModal {
  opened: boolean;
  onClose: () => void;
}

export const StreetPageVGDisclaimerModal: FunctionComponent<VGDisclaimerModal> = ({
  opened,
  onClose,
}) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
      title="Disclaimer"
    >
      <StreetPageVGDisclaimerModalContentWithData />
    </DialogModal>
  );
};
